import styles from './CnisConfiguration.module.css';
import CnisConfigurationForm from './CnisConfigurationForm';
import CnisConfigurationList from './CnisConfigurationList';
import { useTheme } from '../../../../hooks/useTheme';

function CnisConfiguration() {
  const { theme } = useTheme();

  return (
    <div className={styles.container}>
      <div className={styles.settingsTitleContainer}>
        <div className="row">
          <div className={`lg-4 md-12 sm-12 ${styles.leftPanel} ${theme ? styles.borderRightLight : styles.borderRightDark}`}>
            <CnisConfigurationForm />
          </div>
          <div className={`lg-8 md-12 sm-12 ${styles.midPanel}`}>
            <CnisConfigurationList />
          </div>
        </div>
      </div>
    </div>
  );
}
export default CnisConfiguration;
